<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/LokasiAbsensi">Lokasi Absensi</a></li>
                                <li class="breadcrumb-item active">Pengaturan Lokasi Absensi</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Lokasi Absensi</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <label>Nama Lokasi<small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="nama"
                                                    name="nama" placeholder="Nama Lokasi" v-model="nama">
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Jam Kerja Sesuai Dengan<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="absensi" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedabsensi" @update:modelValue="onabsensiChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Peta Lokasi<small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="row px-0">
                                                <input type="number" id="latitude_tmp"
                                                    class="form-control form-control-sm" style="display: none;">
                                                <input type="number" id="longitude_tmp"
                                                    class="form-control form-control-sm" style="display: none;">
                                                <div class="col-sm-9">
                                                    <iframe :src="sourcenya" class="col-sm-12 text-center"
                                                        style="min-height: 95vh;" frameborder="0" id="maps"
                                                        scrolling="no" @load="loadpeta()"></iframe>
                                                </div>
                                                <div class="col-sm-3"
                                                    style="background-color: #ffffff;max-height: 95vh;overflow: auto;">
                                                    <div class="card-header text-center">
                                                        Koordinat Digitasi
                                                        <button type="button" class="btn btn-info btn-sm text-white"
                                                            id="kurang" @click="deleteKoordinat()"
                                                            style="display: none;">
                                                            <i class="far fa-minus-square"></i> Hapus Marker
                                                        </button>
                                                    </div>
                                                    <button type="button" class="btn btn-info btn-sm" id="tambah"
                                                        @click="addKoordinat()" style="display: none;">
                                                        <i class="far fa-plus-square"></i>
                                                    </button>
                                                    <div class="col-sm-12 previous"
                                                        v-for="(koodinatsetuju, counter) in koodinatsetujus"
                                                        v-bind:key="counter">
                                                        <div class="row">
                                                            <div class="row">
                                                                <div class="col-sm-10 text-left">
                                                                    <label>Koordinat Ke {{ counter + 1 }}</label>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <label>Latitude </label>
                                                                    <div class="input-group mb-3">
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text"><i
                                                                                    class="fas fa-map-marker"></i></span>
                                                                        </div>
                                                                        <input type="number"
                                                                            :id="'lat_setuju' + (counter + 1)"
                                                                            class="form-control form-control-sm"
                                                                            step="0.0000001"
                                                                            v-model="koodinatsetuju.latitude">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <label>Longitude </label>
                                                                    <div class="input-group mb-3">
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text"><i
                                                                                    class="fas fa-map-marker-alt"></i></span>
                                                                        </div>
                                                                        <input type="number"
                                                                            :id="'longi_setuju' + (counter + 1)"
                                                                            class="form-control form-control-sm"
                                                                            step="0.0000001"
                                                                            v-model="koodinatsetuju.longitude">
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            &nbsp;
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" id="kosongkandata"
                                        class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="kosongkandata()" data-toggle="tooltip" style="display: none;"
                                        data-placement="left" title="kosong data.."><i class="fas fa-plus-square"></i>
                                        kosong</button>
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" v-if="(secretencData == 'Tambah')" data-toggle="tooltip"
                                        data-placement="left" title="Simpan data.."><i class="fas fa-plus-square"></i>
                                        Simpan</button>
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(secretencData != 'Tambah')" @click="update()" data-toggle="tooltip"
                                        data-placement="left" title="Update data.."><i class="fa fa-check-circle"></i>
                                        Update</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i> Batal</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            &nbsp;
                        </div>
                        <div class="col-sm-12">
                            &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            sourcenya: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            showPassword: false,
            validasi: false,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            dleveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelkabkot: JSON.parse(localStorage.getItem("bdlsistem")),
            levelkelurahan: JSON.parse(localStorage.getItem("sbdsistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            datapesan: '',
            absensi: [],
            dataabsensi: [],
            defaultSelectedabsensi: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedabsensi: '',

            nama: '',
            counter: 0,
            koodinatsetujus: [],
        }
    },
    methods: {
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        addKoordinat() {
            var lat = document.getElementById('latitude_tmp').value;
            var lon = document.getElementById('longitude_tmp').value;
            this.koodinatsetujus.push({
                previous: '',
                expiration: '',
                "latitude": lat,
                "longitude": lon,
            })
        },
        deleteKoordinat() {
            this.koodinatsetujus.splice(this.counter, 1);
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        onabsensiChange(a) {
            try {
                this.selectedabsensi = this.absensi[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/LokasiAbsensi");
        },
        async AmbilData() {
            this.halamanloading = true;
            var mainAPIData = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });

            var random = Math.random();
            await mainAPIData.get("LokasiAbsensi-Jam?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataabsensi = [];
                        this.absensi = [];
                        this.dataabsensi = Response.data.content.data;
                        this.dataabsensi.forEach((item) => {
                            this.absensi.push({
                                label: item.nama,
                                code: this.dataabsensi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.absensi.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingel.get("LokasiAbsensi-ByID?kode=" + this.secretencData + "&random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.nama = Response.data.content.data[0].nama;
                    this.selectedabsensi = Response.data.content.data[0].absensi;
                    var lat = [];
                    var lon = [];
                    lat = Response.data.content.data[0].latitude;
                    lon = Response.data.content.data[0].longitude;
                    for (let i = 0; i < lat.length; i++) {
                        this.koodinatsetujus.push({
                            previous: '',
                            expiration: '',
                            "latitude": lat[i],
                            "longitude": lon[i],
                        })
                    }
                    this.loadpeta();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            this.halamanloading = true;
            var mainAPIData = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIData.get("LokasiAbsensi-Jam?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataabsensi = [];
                        this.absensi = [];
                        this.dataabsensi = Response.data.content.data;
                        this.dataabsensi.forEach((item) => {
                            this.absensi.push({
                                label: item.nama,
                                code: this.dataabsensi.indexOf(item) + 1,
                                tag: item.id,
                            });

                            if (item.id == this.selectedabsensi) {
                                this.defaultSelectedabsensi = {
                                    code: this.dataabsensi.indexOf(item) + 1,
                                    label: item.nama,
                                    tag: item.id
                                };
                            }
                        });
                        this.absensi.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

        },
        validasidata() {
            if ((document.getElementById('nama').value == '') || (document.getElementById('nama').value == null)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Nama Lokasi',
                });
                document.getElementById('nama').focus();
                return false;
            }
            if ((this.selectedabsensi == '') || (this.selectedabsensi == undefined) || (this.selectedabsensi == null) || (this.selectedabsensi == 'null')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih Jam Kerja',
                });
                return false;
            }
            var objectId = 'Mulai Digitasi';
            var iframe = document.getElementById('maps');
            // Most browsers support contentDocument
            var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

            if (iframeDocument) {
                var innerElement = iframeDocument.getElementById('juduldigitasi');
                if (innerElement) {
                    objectId = innerElement.innerHTML;
                } else {
                    console.log('Inner element not found');
                }
            } else {
                console.log('Cannot access iframe document');
            }

            if (objectId != 'Mulai Digitasi') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Selesaikan Digitasi Terlebih Dahulu',
                });
                return false;
            }

            if (this.koodinatsetujus.length < 3) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Peta Lokasi dengan digitasi minimal 3 titik',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        kosongkandata() {
            this.koodinatsetujus = [];
        },
        simpan() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var polyCoords = '';
            var polyCoordsawal = '';
            for (let i = 0; i < this.koodinatsetujus.length; i++) {
                if (i == 0) {
                    polyCoords = polyCoords + this.koodinatsetujus[i].longitude + ' ' + this.koodinatsetujus[i].latitude;
                    polyCoordsawal = ',' + this.koodinatsetujus[i].longitude + ' ' + this.koodinatsetujus[i].latitude;
                }
                else {
                    polyCoords = polyCoords + ',' + this.koodinatsetujus[i].longitude + ' ' + this.koodinatsetujus[i].latitude;
                }
            }
            var polypoly = 'MULTIPOLYGON(((' + polyCoords + polyCoordsawal + ')))';

            var fd = new FormData();
            fd.append("nama", this.nama);
            fd.append("absensi", this.selectedabsensi);
            fd.append("ogc_geom", polypoly);
            fd.append("project_id", this.project_id);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("LokasiAbsensi-Add", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/LokasiAbsensi");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var polyCoords = '';
            var polyCoordsawal = '';
            for (let i = 0; i < this.koodinatsetujus.length; i++) {
                if (i == 0) {
                    polyCoords = polyCoords + this.koodinatsetujus[i].longitude + ' ' + this.koodinatsetujus[i].latitude;
                    polyCoordsawal = ',' + this.koodinatsetujus[i].longitude + ' ' + this.koodinatsetujus[i].latitude;
                }
                else {
                    polyCoords = polyCoords + ',' + this.koodinatsetujus[i].longitude + ' ' + this.koodinatsetujus[i].latitude;
                }
            }
            var polypoly = 'MULTIPOLYGON(((' + polyCoords + polyCoordsawal + ')))';

            var fd = new FormData();
            fd.append("nama", this.nama);
            fd.append("absensi", this.selectedabsensi);
            fd.append("ogc_geom", polypoly);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", this.secretencData);
            fd.append("project_id", this.project_id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("LokasiAbsensi-Update", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/LokasiAbsensi");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
        loadpeta() {
            var polyCoords = '';
            var polypoly = '';
            if (this.koodinatsetujus.length > 0) {
                this.koodinatsetujus.push(this.koodinatsetujus[0]);
                for (let i = 0; i < this.koodinatsetujus.length; i++) {
                    if (i == 0) {
                        polyCoords = polyCoords + this.koodinatsetujus[i].longitude + ' ' + this.koodinatsetujus[i].latitude;
                    }
                    else {
                        polyCoords = polyCoords + ',' + this.koodinatsetujus[i].longitude + ' ' + this.koodinatsetujus[i].latitude;
                    }
                }
            }


            if (this.koodinatsetujus.length > 0) {
                polypoly = btoa('POLYGON((' + polyCoords + '))');
            }


            this.halamanloading = true;
            const message = process.env.VUE_APP_URL_API + '|' + polypoly;
            const iframe = document.getElementById("maps");
            this.sourcenya = '';
            this.sourcenya = '/lockabsen.html';
            iframe.contentWindow.postMessage(message, "*");
            this.halamanloading = false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
        else {
            this.AmbilData();
        }
    }
}
</script>
<style></style>